import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d8463d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statistic-page" }
const _hoisted_2 = { class: "statistic-page__header" }
const _hoisted_3 = { class: "statistic-page__header--left-block" }
const _hoisted_4 = { class: "statistic-page__title" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Динамика ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Окончание подписки:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Отчетов осталось:", -1))

import { computed } from 'vue'
import { getDateFormat } from '@/shared/utils'
import { useUser } from '@/shared/composables'
import { WIndicatorsStatistic } from '@/widgets/WIndicatorsStatistic'
import { DATE_FORMAT } from '@/shared/constants'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { user } = useUser()

const subscriptionEndDate = computed(() =>
  getDateFormat(new Date(user.value.organization.block_at), DATE_FORMAT.dmyLong)
)

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(user).organization.name), 1),
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'StatisticTablePage' }))),
          size: "small",
          type: "primary",
          round: ""
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_row, { class: "statistic-page__info" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_unref(subscriptionEndDate)), 1),
              _createElementVNode("p", null, _toDisplayString(_unref(user).organization.package_count), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_unref(WIndicatorsStatistic))
  ]))
}
}

})